import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { OnboardingFlowService } from '@shared/services/onboarding-flow.service';
import { CommonDataService } from '@shared/services/common-data.service';
import { EMPTY_PATH, PATHS } from '@constants';

export const onboardingStepGuard: CanActivateFn = (route) => {
  const flow = inject(OnboardingFlowService);
  const commonData = inject(CommonDataService);
  const router = inject(Router);

  if (!commonData.hasValidSession()) {
    return router.createUrlTree([PATHS.startProcess]);
  }

  const path = buildFullPath(route);

  if (flow.canAccessStep(path)) {
    return true;
  }

  const redirectTo = flow.getLastAccessiblePath();
  return router.createUrlTree([redirectTo]);
};

function buildFullPath(route: ActivatedRouteSnapshot): string {
  const segments = route.pathFromRoot
    .flatMap((r) => r.url)
    .map((s) => s.path)
    .filter((p) => p !== EMPTY_PATH);
  return segments.join('/');
}
